import { State } from '../../reducers/rootReducer'
import Remark from '../../../entities/Remark'

const modelsRemarksSelector = (state: State): Remark[] => state.modelData.remarks

export default modelsRemarksSelector
